import { NOTNULL_OR_NOTUNDEFINED } from "./EmpUtil";
import { GetFloatToFixedValue } from "./GetFloatValue";

/**
 * @return {string}
 */

export default function FormatPercentage(value) {
  if (NOTNULL_OR_NOTUNDEFINED(value)) {
    value = GetFloatToFixedValue(value, 2);
    value = value.toString();
    value += "%";
  } else {
    value = "--";
  }
  return value;
}
